import React, { useState } from 'react';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';
import EarlyAccessDialog from './EarlyAccessDialog';
import {
  RELEASE_STATE_LABELS,
  RELEASE_STATE_MESSAGES,
  shouldShowReleaseStateNotice,
} from './releaseState';
import { ROUTES } from './routes';

export default function ReleaseStateChip({ releaseState, visible = true }) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  if (!visible || !shouldShowReleaseStateNotice(releaseState)) {
    return null;
  }

  const closeDialog = () => setDialogOpen(false);

  return (
    <>
      <Tooltip title={RELEASE_STATE_MESSAGES.tooltip}>
        <Chip
          label={RELEASE_STATE_LABELS.earlyAccessChip}
          color="warning"
          variant="filled"
          clickable
          onClick={() => setDialogOpen(true)}
          aria-label={`Early Access: ${RELEASE_STATE_MESSAGES.tooltip}`}
          data-testid="early-access-chip"
          sx={{
            fontWeight: 900,
            letterSpacing: 0,
            height: 30,
            '& .MuiChip-label': { px: 1 },
          }}
        />
      </Tooltip>
      <EarlyAccessDialog
        open={dialogOpen}
        onContinue={closeDialog}
        onDetails={() => {
          closeDialog();
          navigate(ROUTES.earlyAccess);
        }}
      />
    </>
  );
}
